import React, { useState, useEffect, useContext, useRef } from 'react';
import {
  Select,
  MenuItem,
  Grid,
  Button,
  Typography,
  TextField,
  FormControl,
  Modal,
  Chip,
  IconButton
} from '@material-ui/core';
import { useSelector, useDispatch } from "react-redux";
import AlertDialog from '../components/AlertDialog';
import { language } from 'config';
import { makeStyles } from '@material-ui/core/styles';
import UsersCombo from '../components/UsersCombo';
import { FirebaseContext } from 'common';
import FaceIcon from '@material-ui/icons/Face';
import ControlPointIcon from '@material-ui/icons/ControlPoint';

const useStyles = makeStyles(theme => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  modal: {
    display: 'flex',
    padding: theme.spacing(1),
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    width: 480,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  container: {
    zIndex: "12",
    color: "#FFFFFF",
    alignContent: 'center'
  },
  title: {
    color: "#000",
  },
  gridcontainer: {
    alignContent: 'center'
  },
  items: {
    margin: 0,
    width: '100%'
  },
  input: {
    fontSize: 18,
    color: "#000"
  },
  inputdimmed: {
    fontSize: 18,
    color: "#737373"
  },
  carphoto: {
    height: '18px',
    marginRight: '10px'
  },
  buttonStyle: {
    margin: 0,
    width: '100%',
    height: '100%'
  }
}));

export default function AddBookings(props) {
  const { api } = useContext(FirebaseContext);
  const {
    addBooking,
    clearBooking,
    MinutesPassed,
  } = api;
  const dispatch = useDispatch();
  const classes = useStyles();
  const locationdata = useSelector(state => state.locationdata);
  const bookingdata = useSelector(state => state.bookingdata);
  const userdata = useSelector(state => state.usersdata);
  const [pickupAddress, setPickupAddress] = useState(language.select_pickup);
  const [dropAddress, setDropAddress] = useState(language.select_drop);
  const [users, setUsers] = useState(null);
  const auth = useSelector(state => state.auth);
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: '' });
  const [userCombo, setUserCombo] = useState(null);
  const rootRef = useRef(null);
  const [passengerModalStatus,setPassengerModalStatus] = useState(false);
  const [locations,setLocations] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
  const [selectedTime, setSelectedTime] = useState("00:00");
  const [coPassengers,setCoPassengers] = useState([]);
  const [textValue, setTextValue] = useState("");
  const getTime = () =>{
    let arr = [];
    for(let i=0;i<=23;i++){
      let hr = i.toString().length === 1? '0' +  i.toString() : i.toString()
      for(let j=0; j<=45;  j=j+15){
        let min = j.toString().length === 1? '0' +  j.toString() : j.toString()
        arr.push(hr + ":" + min);
      }
    }
    return arr;
  }

  const timeList = getTime();


  useEffect(() => {
    if (userdata.users) {
      let arr = [];
      for (let i = 0; i < userdata.users.length; i++) {
        let user = userdata.users[i];
        if (user.usertype === 'rider') {
          arr.push({
            'firstName': user.firstName,
            'lastName': user.lastName,
            'mobile': user.mobile,
            'email': user.email,
            'uid': user.id,
            'desc': user.firstName + ' ' + user.lastName + ' (' + user.mobile + ') ' + user.email,
            'pushToken': user.pushToken
          });
        }
      }
      setUsers(arr);
    }
  }, [userdata.users]);

  useEffect(() => {
    if (locationdata.locations) {
      setLocations(locationdata.locations);
    } else {
      setLocations([]);
    }
  }, [locationdata.locations]);

  const handleGetOptions = (e) => {
    e.preventDefault();
    let selDateTime = new Date(selectedDate + "T" + selectedTime + ":00");
    if (auth.info) {
      if (pickupAddress && dropAddress && (pickupAddress !== dropAddress) && (pickupAddress !== language.select_pickup) && (dropAddress !== language.select_drop)) {
        if (MinutesPassed(selDateTime) >= 0) {
          setPassengerModalStatus(true);
        } else {
          setCommonAlert({ open: true, msg: language.past_booking_error })
        }
      } else {
        setCommonAlert({ open: true, msg: language.select_proper })
      }
    } else {
      setCommonAlert({ open: true, msg: language.must_login })
    }
  };

  const confirmBooking = (e) => {
    e.preventDefault();
    let bookingObject = {
      pickupAddress: pickupAddress,
      dropAddress: dropAddress,
      userDetails: {
        uid: userCombo.uid,
        profile: {
          firstName: userCombo.firstName,
          lastName: userCombo.lastName,
          mobile: userCombo.mobile,
          pushToken: userCombo.pushToken,
          email: userCombo.email
        }
      },
      coPassengers: coPassengers,
      tripdate: new Date(selectedDate + "T" + selectedTime + ":00").toString()
    };
    dispatch(addBooking(bookingObject));
    setCoPassengers([]);
    setPassengerModalStatus(false);
  };

  const handlePassengerModalClose = (e) => {
    e.preventDefault();
    setCoPassengers([]);
    setPassengerModalStatus(false);
  };

  const handleBookingAlertClose = (e) => {
    e.preventDefault();
    dispatch(clearBooking());
    props.history.push('/bookings');
  };

  const handleBookingErrorClose = (e) => {
    e.preventDefault();
    dispatch(clearBooking());
  };

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: '' })
  };

  const handlePickupChange = (event) => {
    setPickupAddress(event.target.value);
  };

  const handleDropChange = (event) => {
    setDropAddress(event.target.value);
  };

  const onDateChange = (event) => {
    setSelectedDate(event.target.value);
  };

  const handleTimeSelect = (event) => {
    setSelectedTime(event.target.value);
  };

  const addNameToPassengers = () => {
    if (textValue) {
      if (coPassengers && coPassengers.length < 3) {
        let found = false;
        for (let i = 0; i < coPassengers.length; i++) {
          if (coPassengers[i] === textValue) {
            found = true;
            break;
          }
        }
        if (found) {
          setCommonAlert({ open: true, msg: language.duplicatePassenger });
        } else {
          let arr = [...coPassengers];
          arr.push(textValue);
          setCoPassengers(arr);
          setTextValue('');
        }
      } else {
        setTextValue('');
        setCommonAlert({ open: true, msg: language.maxPassengers });
      }
    } else {
      setCommonAlert({ open: true, msg: language.emptyPassenger });
    }
  }

  return (
    <div className={classes.container} ref={rootRef}>
      <Grid item xs={12} sm={12} md={8} lg={8}>
        <Grid container spacing={2} >
          <Grid item xs={12}>
            <Typography component="h1" variant="h5" className={classes.title}>
              {language.addbookinglable}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            {users ?
              <UsersCombo
                className={classes.items}
                placeholder={language.select_user}
                users={users}
                value={userCombo}
                onChange={(event, newValue) => {
                  setUserCombo(newValue);
                }}
              />
              : null}
          </Grid>
          <Grid item xs={12}>
            <FormControl style={{ width: '100%' }}>
              <Select
                id="pickup-native"
                value={pickupAddress}
                variant="outlined"
                fullWidth
                onChange={handlePickupChange}
                className={pickupAddress === language.select_pickup ? classes.inputdimmed : classes.input}
              >
                <MenuItem value={language.select_pickup} key={language.select_pickup}>
                  {language.select_pickup}
                </MenuItem>
                {
                  locations.map((location) =>
                    (dropAddress && dropAddress === location.locationName)?null:
                    <MenuItem key={location.locationName} value={location.locationName}>
                      {location.locationName}
                    </MenuItem>
                  )
                }
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl style={{ width: '100%' }}>
              <Select
                id="drop-native"
                value={dropAddress}
                variant="outlined"
                fullWidth
                onChange={handleDropChange}
                className={dropAddress === language.select_drop ? classes.inputdimmed : classes.input}
              >
                <MenuItem value={language.select_drop} key={language.select_drop}>
                  {language.select_drop}
                </MenuItem>
                {
                  locations.map((location) =>
                    (pickupAddress && pickupAddress === location.locationName)?null:
                    <MenuItem key={location.locationName} value={location.locationName}>
                      {location.locationName}
                    </MenuItem>
                  )
                }
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={8}>
            <TextField
              id="datetime-local"
              type="date"
              variant="outlined"
              fullWidth
              value={selectedDate}
              onChange={onDateChange}
              className={classes.input}
              InputProps={{ disableUnderline: true }}
            />
          </Grid>
          <Grid item xs={4}>
            <Select
              value={selectedTime}
              onChange={handleTimeSelect}
              variant="outlined"
              fullWidth
              className={classes.input}
            >
              {
                timeList.map((timeStr) =>
                  <MenuItem key={timeStr} value={timeStr}>
                    {timeStr}
                  </MenuItem>
                )
              }
            </Select>
          </Grid>
          <Grid item xs={12}>
            <Button
              color="primary"
              size="large"
              className={classes.buttonStyle}
              onClick={handleGetOptions}
              variant="contained"
              style={{ height: 52 }}
            >
              <i className="fas fa-car" />
              {language.book}
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={passengerModalStatus}
        onClose={handlePassengerModalClose}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <div className={classes.paper}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Typography xs={12} component="h1" variant="h5" style={{ marginBottom: 10 }}>
                {language.coPassengers}
              </Typography>
              {coPassengers.map((item) =>
                <Chip
                  style={{ marginRight: 5, marginBottom: 5 }}
                  icon={<FaceIcon />}
                  label={item}
                  onDelete={() => {
                    let arr = [...coPassengers];
                    arr.splice(arr.indexOf(item), 1);
                    setCoPassengers(arr);
                  }}
                  color="secondary"
                />
              )}
              <Grid container>
                <Grid item xs={10}>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    id="coPassenger"
                    label={language.coPassenger}
                    name="coPassenger"
                    autoComplete="coPassenger"
                    onChange={(e) => setTextValue(e.target.value)}
                    value={textValue}
                    autoFocus
                  />
                </Grid>
                <Grid item xs={2} style={{marginTop:20}}>
                  <IconButton onClick={addNameToPassengers} color="primary" size='large'>
                    <ControlPointIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Button onClick={confirmBooking} variant="contained" color="success">
                {language.book_now}
              </Button>
              <Button onClick={handlePassengerModalClose} variant="contained" color="danger" style={{ marginLeft: 5 }}>
                {language.cancel}
              </Button>
            </Grid>
          </Grid>
        </div>
      </Modal>
      <AlertDialog open={bookingdata.booking ? true : false} onClose={handleBookingAlertClose}>{bookingdata.booking ? language.booking_success + bookingdata.booking.booking_id : null}</AlertDialog>
      <AlertDialog open={bookingdata.error.flag} onClose={handleBookingErrorClose}>{bookingdata.error.msg}</AlertDialog>
      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>{commonAlert.msg}</AlertDialog>
    </div>
  );
}